import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Coupon Management
    SETTING_LOAD_COUPON_CATEGORY,
    SETTING_CREATE_COUPON_CATEGORY,
    SETTING_UPDATE_COUPON_CATEGORY,
    SETTING_DELETE_COUPON_CATEGORY,

    SETTING_LOAD_COUPON,
    SETTING_CREATE_COUPON,
    SETTING_UPDATE_COUPON,
    SETTING_DELETE_COUPON,

    // SETTING_UPDATE_COUPON_STATUS,
    // END Coupon Management

} from "../../actions";

import {
    // Coupon Management
    settingGetCouponCategory,
    settingAddCouponCategory,
    settingUpdateCouponCategory,
    settingDeleteCouponCategory,

    settingGetCoupon,
    settingAddCoupon,
    settingUpdateCoupon,
    settingDeleteCoupon,
    // settingUpdateChangeStatusCoupon,

    // END Coupon Management

} from "../../../helpers/setting-api";

import {
    getCouponCategory,
    getCouponCategorySuccess,
    getCoupon,
    getCouponSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Coupon Management
function* settingManagementLoadCouponCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetCouponCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_coupon_category,
                    value: item.id_coupon_category,
                }
            ));
            yield put(getCouponCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddCouponCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddCouponCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getCouponCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateCouponCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdateCouponCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getCouponCategory({ spa_id: payload.spa_id }, token));
            yield put(getCoupon({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteCouponCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteCouponCategory(items, token);
        if (dataRes.status === 'success') yield put(getCouponCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadCoupon({ payload, token }) {
    try {
        const dataRes = yield settingGetCoupon(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_coupon_detail,
                    value: item.id_coupon_detail,
                }
            ));
            yield put(getCouponSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddCoupon({ payload, token }) {
    try {
        const dataRes = yield settingAddCoupon(payload, token);
        if (dataRes.status === 'success') {
            yield put(getCoupon({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateCoupon({ payload, token }) {
    try {
        const dataRes = yield settingUpdateCoupon(payload, token);
        if (dataRes.status === 'success') {
            yield put(getCoupon({ spa_id: payload.spa_id }, token));
            // yield put(getCouponCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementChangeStatusCoupon({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateChangeStatusCoupon(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getCoupon({ spa_id: payload.spa_id }, token));

//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

function* settingManagementDeleteCoupon({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteCoupon(items, token);
        if (dataRes.status === 'success') yield put(getCoupon({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Coupon Management

// Coupon Management
export function* watchLoadCouponCategory() {
    yield takeEvery(
        SETTING_LOAD_COUPON_CATEGORY,
        settingManagementLoadCouponCategory
    );
}
export function* watchAddCouponCategory() {
    yield takeEvery(
        SETTING_CREATE_COUPON_CATEGORY,
        settingManagementAddCouponCategory
    );
}
export function* watchUpdateCouponCategory() {
    yield takeEvery(
        SETTING_UPDATE_COUPON_CATEGORY,
        settingManagementUpdateCouponCategory
    );
}
export function* watchDeleteCouponCategory() {
    yield takeEvery(
        SETTING_DELETE_COUPON_CATEGORY,
        settingManagementDeleteCouponCategory
    );
}

export function* watchLoadCoupon() {
    yield takeEvery(
        SETTING_LOAD_COUPON,
        settingManagementLoadCoupon
    );
}
export function* watchAddCoupon() {
    yield takeEvery(
        SETTING_CREATE_COUPON,
        settingManagementAddCoupon
    );
}
export function* watchUpdateCoupon() {
    yield takeEvery(
        SETTING_UPDATE_COUPON,
        settingManagementUpdateCoupon
    );
}
// export function* watchChangeStatusCoupon() {
//     yield takeEvery(
//         SETTING_UPDATE_COUPON_STATUS,
//         settingManagementChangeStatusCoupon
//     );
// }
export function* watchDeleteCoupon() {
    yield takeEvery(
        SETTING_DELETE_COUPON,
        settingManagementDeleteCoupon
    );
}

// END Coupon Management

export default function* rootSaga() {
    yield all([
        //  Coupon Management 
        fork(watchLoadCouponCategory),
        fork(watchAddCouponCategory),
        fork(watchUpdateCouponCategory),
        fork(watchDeleteCouponCategory),

        fork(watchLoadCoupon),
        fork(watchAddCoupon),
        fork(watchUpdateCoupon),
        // fork(watchChangeStatusCoupon),
        fork(watchDeleteCoupon),

    ])
}